import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} cerca. Anotado.",
  "alert.toast.escalation": "{hazard} cerca. Ahora peor.",
  "alert.toast.inPath": "{hazard} en tu dirección. Lógico.",
  "alert.toast.allClear": "Normal otra vez cerca de {place}.",
  "alert.toast.tap": "Detalles, si te interesa.",
  "alert.takeover.title": "{hazard}. Es el momento de moverse.",
  "alert.takeover.details": "Los detalles",
  "alert.takeover.dismiss": "Anotado",
  "now.status.allClear": "Sin novedad.",
  "now.status.stayAware": "Ojos abiertos.",
  "now.status.sub.allClear": "Nada en tu radio. Disfrútalo.",
  "now.activity.empty": "Nadie ha informado de nada. Sospechoso.",
  "onboarding.promise.tagline": "Vecinos avisando a vecinos. Revolucionario.",
  "onboarding.promise.continue": "Bueno, vamos",
  "onboarding.home.browse": "Solo mirando",
  "you.voice.intro": "Elige lo directo que quieres que sea esto.",
};
